module.exports = __webpack_public_path__ + "img/cattunnel26.cb0a2e6e.jpg";